import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useApiActions, usePending } from "state/hooks";
import { selectEntity } from "state/selectors/data";
import { runSyncTask, syncData } from "cms/state/actions/integrations";
import Popover from "components/Popover";
import { CircularProgress } from "@material-ui/core";
import DateDiff from "components/DateDiff";
import SelectList, { SelectListItem } from "playground/ui/SelectList";
import { FormLayout, OverlayForm } from "playground/cms/Form";
import { ResourceForm } from "../Resources";
import SyncTasksForm from "./SyncTasksForm";
import { renderForm } from "./SyncTasks";
//import PropTypes from 'prop-types';

function selectSyncTask(store, type) {
    const tasks = store.data?.["cms.sync-tasks"] || {};
    const active = Object.values(tasks).filter((task) => {
        return task.active;
    });
    const task = active[0];
    if (!task) return {};
    const integration = selectEntity(
        store,
        "cms.integrations",
        task.integration
    );
    return { task, integration };
}

export function ListSyncTask(props) {
    const { task, integration } = useSelector((store) =>
        selectSyncTask(store, "offers")
    );
    const { onSyncData, onRunSyncTask } = useApiActions({
        onSyncData: syncData,
        onRunSyncTask: runSyncTask,
    });

    const [showTask, setShowTask] = useState(false);
    const closeTask = () => setShowTask(false);
    const runSync = () => onRunSyncTask(task.id, props.type);

    const isPending = usePending(task?.id);

    if (!task) return null;

    return (
        <>
            <Popover
                trigger={({ onClick }) => (
                    <div onClick={onClick}>
                        {isPending ? (
                            <CircularProgress
                                color={"inherit"}
                                size={20}
                                thickness={4.2}
                            />
                        ) : (
                            <>
                                {integration?.type} {props.list}
                                <DateDiff value={task.synced_at} />
                            </>
                        )}
                    </div>
                )}
                content={({ onClose }) => (
                    <SelectList onClick={onClose}>
                        <SelectListItem onClick={() => runSync()}>
                            Synchronizuj teraz
                        </SelectListItem>
                        <SelectListItem onClick={() => setShowTask(true)}>
                            Ustawienia synchronizacji
                        </SelectListItem>
                    </SelectList>
                )}
            />
            <OverlayForm open={showTask && task} onClose={closeTask}>
                {task && (
                    <ResourceForm
                        type={"cms.sync-tasks"}
                        id={task.id}
                        onClose={closeTask}
                    >
                        {renderForm(props)}
                    </ResourceForm>
                )}
            </OverlayForm>
        </>
    );
}

ListSyncTask.propTypes = {};

ListSyncTask.defaultProps = {};

export default ListSyncTask;
